import { Ticket } from "lucide-react";
import { getPromo } from "@/lib/promo";

export function PromoBanner() {
  const code = getPromo();
  if (!code) return null;
  return (
    <div className="mx-5 mt-5 flex items-center gap-3 rounded-2xl border border-dashed border-[#D4AF37]/50 bg-[#D4AF37]/10 px-4 py-3" data-testid="promo-banner">
      <Ticket size={20} className="shrink-0 text-[#D4AF37]" />
      <p className="text-sm leading-snug text-[#E4E4E7]">
        Hai ricevuto il codice <b className="tracking-wider text-[#E5C158]" data-testid="promo-banner-code">{code}</b>. Lo troverai già inserito al momento dell'abbonamento. Tienilo da parte se installi l'app.
      </p>
    </div>
  );
}
